module.exports = {
          srcSet: __webpack_public_path__ + "e487bd1c8bc9ec9ef0363931358208b4-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "e487bd1c8bc9ec9ef0363931358208b4-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "e487bd1c8bc9ec9ef0363931358208b4-24.png",
          toString:function(){return __webpack_public_path__ + "e487bd1c8bc9ec9ef0363931358208b4-24.png"},
          
          width: 24,
          height: 24
        }